import { useEffect, useRef } from 'react';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import { markError } from '../store/actions';
import { GlobalState } from '../store/types';

export const useMonitorMessageDelivery = () => {
  const timer = useRef<NodeJS.Timeout | null>(null);
  const dispatch = useDispatch();
  const messages = useSelector(
    (state: GlobalState) => state.messages.messages,
    shallowEqual
  );

  const listOfMessagesWithoutAck = messages.filter(
    (message) => !message.error && !message.acknowledged && message.sender === 'client'
  );

  useEffect(() => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }

    if (listOfMessagesWithoutAck.length === 0) return;

    timer.current = setInterval(() => {
      const currentTime = Date.now();

      listOfMessagesWithoutAck.forEach((message) => {
        const messageTimestamp = message.timestamp as unknown as number;
        if (message.id) {
          const timeDifference = currentTime - messageTimestamp;
          if (timeDifference > 10_000) {
            dispatch(markError(message.id));
          }
        }
      });
    }, 1000);

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
        timer.current = null;
      }
    };
  }, [listOfMessagesWithoutAck]);
};
